module.exports = __webpack_public_path__ + "img/gb2262.prt.fb6b3e69.jpg";